define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/GalleryItemRowCountProperty",
        "../properties/GalleryItemTextLineCountProperty",
        "../properties/GalleryItemWidthProperty",
        "../properties/DisplayStateProperty",
        "../properties/ScrollToSelectionProperty",
        "../properties/DndEnabledProperty",
        "../properties/ListViewDisplayDensityProperty",
        "../properties/OptionsEnabledProperty",
        "../properties/OwnsFooterProperty",
        "dojo/i18n!l10n/nls/toolstrip"
    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, GalleryItemRowCountProperty, GalleryItemTextLineCountProperty, GalleryItemWidthProperty,
              DisplayStateProperty, ScrollToSelectionProperty, DndEnabledProperty, ListViewDisplayDensityProperty, OptionsEnabledProperty, OwnsFooterProperty,
              toolstripL10n) {
        var hash = {};

        hash[TypeConstants.GALLERY_PANEL] = lang.mixin({}, {
                favCategoryId: {
                    type: "string",
                    notInAction: true,
                    required: false,
                    defaultValue: ""
                },
                footerId: {
                    type: "string",
                    notInAction: true,
                    required: false,
                    defaultValue: ""
                },
                placeholderText: {
                    type: "string",
                    notInAction: true,
                    required: false,
                    defaultValue: toolstripL10n.gallerySearch
                },
                hideDisabledItems: {
                    type: "boolean",
                    notInAction: true,
                    required: false,
                    defaultValue: false
                },
                showHeader: {
                    type: "boolean",
                    notInAction: true,
                    required: false,
                    defaultValue: true
                },
        ﻿    favoritesEnabled: {
                type: "boolean",
                notInAction: true,
                required: false,
                defaultValue: true
            },
            reorderCategory: {
                    type: "boolean",
                    notInAction: true,
                    required: false,
                    defaultValue: true
                },
                width: {
                    type: "string",
                    notInAction: true,
                    required: false,
                    defaultValue: "auto"
                },
                height: {
                    type: "string",
                    notInAction: true,
                    required: false,
                    defaultValue: "auto"
                }
            }, TypeProperty, TagProperty, GalleryItemRowCountProperty, GalleryItemTextLineCountProperty,
            GalleryItemWidthProperty, DisplayStateProperty, ScrollToSelectionProperty, DndEnabledProperty,
            ListViewDisplayDensityProperty, OptionsEnabledProperty, OwnsFooterProperty);

        return hash;
    });